import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AppConfig } from "../../../../services/app-config.service";
import { CompatibilityGuidelinesAPIConstant } from "../constant/compatibility-guidelines.constant";
import { MarkCompatibilityGuideFileDownloaded } from "../model/compatibility-guidelines.model";
import { RestService } from "../../../core/service/rest.service";

@Injectable({
    providedIn: 'root'
})
export class CompatibilityGuidelinesService {
    httpOptions: any = {
        Headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    };

    mediaHttpOptions: any = {
        Headers: new HttpHeaders({ 'Content-Type': 'multipart/form-data' })
    };

    apiUrl = AppConfig.settings.apiUrl;

    constructor(private httpClient: HttpClient, private rest:RestService) {
    }

    createCompatibilityGuidelines(payload: any) {
        return this.httpClient.post(`${this.apiUrl}${CompatibilityGuidelinesAPIConstant.COMPATIBILITYGUIDLINES_CREATE}`, payload, this.mediaHttpOptions);
    }

    getCompatibilityGuidelines(params: any = null) {
        return this.httpClient.get(`${this.apiUrl}${CompatibilityGuidelinesAPIConstant.COMPATIBILITYGUIDLINES}${params?.preventLoader? '?preventLoader=true':''}`, this.httpOptions);
    }

    deleteCompatibilityGuidelines(parms:any) {
        return this.rest.delete(`${CompatibilityGuidelinesAPIConstant.COMPATIBILITYGUIDLINES}`, parms);
    }

    markCompatibilityGuidelineFileDownloaded(payload: MarkCompatibilityGuideFileDownloaded) {
        return this.httpClient.post(`${this.apiUrl}${CompatibilityGuidelinesAPIConstant.MARKCOMPATIBILITYGUIDEFILEDOWNLOADED}`, payload, this.httpOptions);
    }
    GetLastUploaded(params: any = null) {
        return this.httpClient.get(`${this.apiUrl}${CompatibilityGuidelinesAPIConstant.GETLASTUPLOADED}${params?.preventLoader? '?preventLoader=true':''}`, this.httpOptions);
    }

}